<form-factory
  *ngIf="hasSelectedDiagnosis"
  class="diagnosis-save-group"
  [formGroup]="form"
  [model]="saveGroup"
  (onChange)="handleChange($event)"></form-factory>